'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import clsx from 'clsx';
import { buildRoute } from '@headless-workspace/config';
import {
    DividerDirection,
    GlowButton,
    GlowDivider,
    GlowTextBody,
    GlowTextList,
    GlowTitle,
    PropsWithLocale,
} from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { AppointmentButton, StoreSearchContainer } from '../../../../../src';

type StoreLocatorProps = PropsWithLocale & {
    favoriteStoreItems: string[];
};

export const StoreLocator: Component<StoreLocatorProps> = ({ locale, favoriteStoreItems }) => {
    const t = useTranslations('Header.storesAndServices');
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    return (
        <>
            <div
                className={'flex flex-col flex-1 gap-2'}
                onMouseLeave={handleMouseLeave}
                onMouseEnter={handleMouseEnter}
            >
                <GlowTitle text={t('banner.label.storesTitle')} fontSize={'title4'} />
                <StoreSearchContainer isHoveredOutSide={isHovered} />
                <div>
                    <GlowTextBody text={t('banner.label.chooseStore')} />
                    <GlowTextList className={'flex-1 marker:text-text-primary'} texts={favoriteStoreItems} />
                </div>
            </div>
            <GlowDivider direction={DividerDirection.Vertical} />
            <div className={clsx('flex flex-col flex-1 gap-2')}>
                <div className={'flex flex-col gap-y-0.5'}>
                    <GlowTitle text={t('banner.label.servicesTitle')} fontSize={'title4'} />
                    <GlowTextBody text={t('banner.label.servicesDescription')} />
                </div>
                <div className={'flex flex-col gap-1'}>
                    <AppointmentButton />
                    <GlowButton
                        className={'transition-backgroundOutline'}
                        variant={'secondary'}
                        label={t('banner.action.seeServices')}
                        href={buildRoute(locale, 'allServices')}
                    />
                </div>
            </div>
        </>
    );
};
